// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__1HC8E","layout__main":"Layout_layout__main__zQlnz"};